
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compare/[platform]-alternatives",
      function () {
        return require("private-next-pages/compare/[platform]-alternatives.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compare/[platform]-alternatives"])
      });
    }
  